import { useState, useEffect } from 'react';
import api from '../config/api';
import useStore from '../config/store';

// Una sola consulta por organización en la sesión
const requests = {}; // organizationId → promesa en curso
const resolved = {}; // organizationId → país (o null) ya leído

const loadCountry = (organization, authToken) => {
  if (!requests[organization]) {
    requests[organization] = api
      .get(`/organizations/${organization}`, { headers: { Authorization: `Bearer ${authToken}` } })
      .then((res) => {
        const data = res.data.response;
        const country = data?.status_response === 'OK' ? (data.data?.country || null) : null;
        resolved[organization] = country;
        return country;
      })
      .catch((err) => {
        console.error('Error leyendo el país de la organización:', err);
        delete requests[organization]; // se reintenta en el próximo montaje
        return null;
      });
  }
  return requests[organization];
};

/**
 * País de operación de la organización activa (organization.country).
 * Sin país, o si no se puede leer, se asume Chile (mismo criterio que el
 * backend). La verificación de antecedentes solo existe para organizaciones
 * que operan en Chile; fuera de Chile está en espera (PLAN_MASIVO_PORTAL).
 * @returns {{ country: string|null, operatesInChile: boolean, loading: boolean }}
 */
const useOrganizationCountry = () => {
  const { organization, authToken } = useStore.getState();
  const known = Boolean(organization) && Object.prototype.hasOwnProperty.call(resolved, organization);
  const [country, setCountry] = useState(known ? resolved[organization] : null);
  const [loading, setLoading] = useState(Boolean(organization && authToken) && !known);

  useEffect(() => {
    if (!organization || !authToken || known) return undefined;
    let cancelled = false;
    loadCountry(organization, authToken).then((value) => {
      if (cancelled) return;
      setCountry(value);
      setLoading(false);
    });
    return () => { cancelled = true; };
    // Solo al montar (o al cambiar de organización)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization, authToken]);

  return {
    country,
    operatesInChile: String(country || 'CL').toUpperCase() === 'CL',
    loading,
  };
};

export default useOrganizationCountry;
